import PropTypes from 'prop-types';
import Modal from 'components/templates/Modal/Modal';
import * as ALOOMA from 'consts/alooma';
import ModalBodyGiftCardEmailSend from 'components/molecules/ModalBodyGiftCardEmailSend/ModalBodyGiftCardEmailSend';

const ModalGiftCardEmailSend = props => {
  const { closeModal, sourcePage } = props;

  return (
    <Modal
      source={sourcePage}
      aloomaModalType={ALOOMA.MODAL_TYPES.POPUP}
      aloomaModalName={ALOOMA.MODAL_NAMES.GIFT_CARD_EMAIL_SEND}
      onClose={closeModal}
      sendPageView={false}
    >
      <ModalBodyGiftCardEmailSend {...props} />
    </Modal>
  );
};

ModalGiftCardEmailSend.propTypes = {
  closeModal: PropTypes.func.isRequired,
  sourcePage: PropTypes.string.isRequired,
};

export default ModalGiftCardEmailSend;
